import { api } from 'api';
import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import { REFERRAL_CODE, REGISTER_PREFIX } from 'constants';
import Cookies from 'helpers/cookies';
import useCommonStore from 'hooks/useCommonStore';
import usePortalModal from 'hooks/usePortalModal';
import useQuery from 'hooks/useQuery';
import React, { useEffect, useState } from 'react';
import { domUtils } from 'utils';

const withCheckReferralLinkExpired = (Component) => {
  const CheckReferralLinkExpiredComponent = (props) => {
    const { showPortalModalName } = usePortalModal();
    const query = useQuery();
    const referralCode =
      query.get('referralCode') || Cookies.get(REFERRAL_CODE);
    const { setLoading } = useCommonStore();

    const [isReferralLinkChecking, setReferralLinkChecking] = useState(true);

    const onCheckReferralLinkExpired = async () => {
      setLoading(true);
      try {
        const { data } = await api.checkValidReferralCode(referralCode);
        if (data) {
          const { isValid } = data || {};
          if (!isValid) {
            showPortalModalName({
              name: PORTAL_NAME_MODAL_DEFINE.REFERRAL_LINK_EXPIRED_MODAL,
              action: () => {
                Cookies.remove(REFERRAL_CODE);
                domUtils.replaceUrlWithReload({ path: REGISTER_PREFIX });
              },
            });
          } else {
            Cookies.set(REFERRAL_CODE, referralCode);
            setReferralLinkChecking(false);
          }
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setReferralLinkChecking(false);
        console.error(error?.message);
      }
    };

    useEffect(() => {
      if (!referralCode) {
        setReferralLinkChecking(false);
        return;
      }
      onCheckReferralLinkExpired();
    }, []);

    const newProps = {
      ...props,
      isReferralLinkChecking,
    };
    return <Component {...newProps} />;
  };
  return CheckReferralLinkExpiredComponent;
};

export default withCheckReferralLinkExpired;
